export function buildImportReviewCoverage(summary = {}) {
  return [
    {
      key: "changed-code",
      label: "Changed code",
      count: Number(summary.changedCode || 0),
      present: Number(summary.changedCode || 0) > 0,
      color: "warning",
      filterValue: "changed_only",
      filterLabel: "Show changed items",
    },
    {
      key: "changed-docs",
      label: "Changed docs",
      count: Number(summary.changedDocs || 0),
      present: Number(summary.changedDocs || 0) > 0,
      color: "warning",
      filterValue: "changed_docs_only",
      filterLabel: "Show changed docs",
    },
    {
      key: "new-items",
      label: "New items",
      count: Number(summary.newCode || 0) + Number(summary.newDocs || 0),
      present: Number(summary.newCode || 0) + Number(summary.newDocs || 0) > 0,
      color: "info",
      filterValue: "new",
      filterLabel: "Show new items",
    },
    {
      key: "ready-items",
      label: "Ready to save",
      count: Number(summary.readyToSave || 0),
      present: Number(summary.readyToSave || 0) > 0,
      color: "primary",
      filterValue: "ready",
      filterLabel: "Show ready items",
    },
    {
      key: "all-items",
      label: "All items",
      count: Number(summary.totalCode || 0) + Number(summary.totalDocs || 0),
      present:
        Number(summary.totalCode || 0) + Number(summary.totalDocs || 0) > 0,
      color: "secondary",
      filterValue: "all",
      filterLabel: "Reset filters",
    },
  ];
}

export function getImportReviewCoverageHint(summary = {}) {
  const changedCode = Number(summary.changedCode || 0);
  const newCode = Number(summary.newCode || 0);
  const changedDocs = Number(summary.changedDocs || 0);
  const newDocs = Number(summary.newDocs || 0);

  const present = [];
  if (changedCode) present.push(`${changedCode} changed code file(s)`);
  if (newCode) present.push(`${newCode} new code file(s)`);
  if (changedDocs) present.push(`${changedDocs} changed document(s)`);
  if (newDocs) present.push(`${newDocs} new document(s)`);

  if (!present.length) {
    return "This package does not yet contain a mixed import scenario. Import a package with both code and docs to exercise the grouped review filters.";
  }

  return `This package includes ${present.join(", ")}. Use the quick filters below to test the grouped review flow before applying changes.`;
}
